import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

// Dumb switch: the caller owns the checked state and the optimistic-flip/revert
// logic (see AiDecisionLogicComponent.toggleAiDecisionLogic for the reference
// pattern) — this component only relays the click.
@Component({
  selector: 'app-ui-toggle',
  templateUrl: './ui-toggle.component.html',
  styleUrls: ['./ui-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() label = '';
  @Input() ariaLabel = '';
  @Input() showState = true;
  @Input() labelAfter = false;

  @Output() toggled = new EventEmitter<void>();

  onToggle(): void {
    if (this.disabled) {
      return;
    }
    this.toggled.emit();
  }
}
